import styled from 'styled-components';
import { Handle as HandleBase, Position } from 'reactflow';

const GraphNodeHandle = styled(HandleBase)<{
  $extendHandle?: boolean;
  $isHighlighted?: boolean;
  $nodeHeight: number;
}>`
  cursor: grab !important;
  top: ${({ $nodeHeight }) => $nodeHeight / 2}px;
  opacity: ${({ $extendHandle }) => ($extendHandle ? 1 : 0)};
  width: ${({ $extendHandle }) => ($extendHandle ? '8px' : 0)};

  ${({ position, $extendHandle }) =>
    $extendHandle
      ? position === Position.Left
        ? 'margin-left: -4px'
        : 'margin-right: -4px'
      : position === Position.Left
      ? 'margin-left: 4px'
      : 'margin-right: 4px'};

  &.react-flow__handle {
    background: ${({ theme, $isHighlighted }) =>
      $isHighlighted
        ? theme.palette.accent.secondary
        : theme.palette.surface.light};
    max-height: 2px !important;
    min-height: 2px !important;
  }
`;

export default GraphNodeHandle;
